{
  "id": "facebook.com",
  "version": 2,
  "name": "Facebook",
  "author": "SR",
  "date": "2023-06-23",
  "url": "https://www.facebook.com",
  "strings": {
    "en": {
      "name": "Facebook",
      "help": [
        "https://www.facebook.com/dyi",
        "(Log in with your Facebook account)",
        "For Format select 'JSON'.",
        "For Media quality you can select any option.",
        "For Data range select 'All time'.",
        "Scroll down and click 'Request a download'.",
        "Wait for an email or Facebook notification and follow the instructions (usually takes 2-10 minutes)."
      ]
    },
    "de": {
      "name": "Facebook",
      "help": [
        "https://www.facebook.com/dyi",
        "(Melde dich an)",
        "Wähle unter Format 'JSON' aus.",
        "Wähle unter Datumsbereich 'Gesamter Zeitraum' aus",
        "Klicke ganz unten auf 'Download anfordern'.",
        "Du erhälst eine Facebook Notification und eine Email zum Herunterladen (dauert etwa 2-10 Minuten)."
      ]
    }
  },
  "instructions": [
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "group_interactions_v2": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "name": [{ "type": "string" }, { "type": "empty" }],
                          "description": [{ "type": "string" }, { "type": "empty" }],
                          "entries": [
                            {
                              "type": "array",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "properties": {
                                    "data": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "name": [{ "type": "string" }],
                                          "value": [{ "type": "string" }],
                                          "uri": [{ "type": "string" }]
                                        }
                                      }
                                    ]
                                  }
                                }
                              ]
                            }
                          ]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "group_interactions_v2", null, "entries"],
          "category": "Messages",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "group_interactions_v2", null, "entries", null]
            }
          ],
          "selectedTimestamps": [],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "custom_audiences_all_types_v2": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "advertiser_name": [{ "type": "string" }],
                          "has_data_file_custom_audience": [{ "type": "boolean" }],
                          "has_remarketing_custom_audience": [{ "type": "boolean" }],
                          "has_in_person_store_visit": [{ "type": "boolean" }]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "custom_audiences_all_types_v2"],
          "category": "Activity",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "custom_audiences_all_types_v2", null]
            }
          ],
          "selectedTimestamps": [],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "installed_apps_v2": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "name": [{ "type": "string" }],
                          "added_timestamp": [{ "type": "number" }, { "type": "empty" }],
                          "user_app_scoped_id": [{ "type": "number" }],
                          "category": [{ "type": "string" }],
                          "removed_timestamp": [{ "type": "number" }, { "type": "empty" }]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "installed_apps_v2"],
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "installed_apps_v2", null]
            }
          ],
          "selectedTimestamps": [],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "app_posts_v2": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "timestamp": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            }
                          ],
                          "attachments": [
                            {
                              "type": "array",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "properties": {
                                    "data": [
                                      {
                                        "type": "array",
                                        "anyOf": [
                                          {
                                            "type": "object",
                                            "properties": {
                                              "external_context": [
                                                {
                                                  "type": "object",
                                                  "properties": {
                                                    "name": [{ "type": "string" }],
                                                    "url": [{ "type": "string" }]
                                                  }
                                                }
                                              ]
                                            }
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                }
                              ]
                            }
                          ],
                          "title": [{ "type": "string" }]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "app_posts_v2"],
          "category": "Posts",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null, "app_posts_v2", null] }],
          "selectedTimestamps": [
            {
              "path": ["data", null, "app_posts_v2", null, "timestamp"],
              "arguments": { "factor": 1000 }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "off_facebook_activity_v2": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "name": [{ "type": "string" }],
                          "events": [
                            {
                              "type": "array",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "properties": {
                                    "id": [
                                      {
                                        "type": "number",
                                        "supposedUsage": {
                                          "format": "time",
                                          "argument": { "factor": 0.001 }
                                        }
                                      }
                                    ],
                                    "type": [{ "type": "string" }],
                                    "timestamp": [
                                      {
                                        "type": "number",
                                        "supposedUsage": {
                                          "format": "time",
                                          "argument": { "factor": 1000 }
                                        }
                                      }
                                    ]
                                  }
                                }
                              ]
                            }
                          ]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "off_facebook_activity_v2", null, "events"],
          "category": "Activity",
          "subcategory": [
            { "type": "text", "value": "Activity on " },
            {
              "type": "data",
              "value": ["data", null, "off_facebook_activity_v2", null, "name"]
            }
          ],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "off_facebook_activity_v2", null, "name"]
            },
            { "type": "text", "value": ": " },
            {
              "type": "data",
              "value": ["data", null, "off_facebook_activity_v2", null, "events", null, "type"]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "off_facebook_activity_v2", null, "events", null, "timestamp"],
              "arguments": { "factor": 1000 },
              "template": ["data", null, "off_facebook_activity_v2", null, "events"]
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "voting_location_v2": [
                  {
                    "type": "object",
                    "properties": { "voting_location": [{ "type": "string" }] }
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data"],
          "category": "Location",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null] }],
          "selectedTimestamps": [],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "voting_reminders_v2": [
                  {
                    "type": "object",
                    "properties": { "voting_reminders": [{ "type": "string" }] }
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data"],
          "category": "Location",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null] }],
          "selectedTimestamps": [],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "your_events_v2": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "name": [{ "type": "string" }],
                          "start_timestamp": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            }
                          ],
                          "end_timestamp": [{ "type": "number" }, { "type": "empty" }],
                          "place": [
                            {
                              "type": "object",
                              "properties": { "name": [{ "type": "string" }] }
                            }
                          ],
                          "description": [{ "type": "string" }, { "type": "empty" }],
                          "create_timestamp": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "your_events_v2"],
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null, "your_events_v2", null] }],
          "selectedTimestamps": [
            {
              "path": ["data", null, "your_events_v2", null, "start_timestamp"],
              "arguments": { "factor": 1000 }
            },
            {
              "path": ["data", null, "your_events_v2", null, "create_timestamp"],
              "arguments": { "factor": 1000 }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "events_invited_v2": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "name": [{ "type": "string" }],
                          "start_timestamp": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            }
                          ],
                          "end_timestamp": [{ "type": "number" }, { "type": "empty" }]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "events_invited_v2"],
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "events_invited_v2", null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "events_invited_v2", null, "start_timestamp"],
              "arguments": { "factor": 1000 }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "event_responses_v2": [
                  {
                    "type": "object",
                    "properties": {
                      "events_joined": [
                        {
                          "type": "array",
                          "anyOf": [
                            {
                              "type": "object",
                              "properties": {
                                "name": [{ "type": "string" }],
                                "start_timestamp": [
                                  {
                                    "type": "number",
                                    "supposedUsage": {
                                      "format": "time",
                                      "argument": { "factor": 1000 }
                                    }
                                  }
                                ],
                                "end_timestamp": [
                                  {
                                    "type": "number",
                                    "supposedUsage": {
                                      "format": "time",
                                      "argument": { "factor": 1000 }
                                    }
                                  }
                                ],
                                "place": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "name": [{ "type": "string" }]
                                    }
                                  },
                                  { "type": "empty" }
                                ],
                                "description": [{ "type": "string" }, { "type": "empty" }],
                                "create_timestamp": [
                                  {
                                    "type": "number",
                                    "supposedUsage": {
                                      "format": "time",
                                      "argument": { "factor": 1000 }
                                    }
                                  },
                                  { "type": "empty" }
                                ]
                              }
                            }
                          ]
                        }
                      ],
                      "events_declined": [
                        {
                          "type": "array",
                          "anyOf": [
                            {
                              "type": "object",
                              "properties": {
                                "name": [{ "type": "string" }],
                                "start_timestamp": [
                                  {
                                    "type": "number",
                                    "supposedUsage": {
                                      "format": "time",
                                      "argument": { "factor": 1000 }
                                    }
                                  }
                                ],
                                "end_timestamp": [
                                  {
                                    "type": "number",
                                    "supposedUsage": {
                                      "format": "time",
                                      "argument": { "factor": 1000 }
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "event_responses_v2", "events_joined"],
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "event_responses_v2", "events_joined", null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "event_responses_v2", "events_joined", null, "end_timestamp"],
              "arguments": { "factor": 1000 }
            },
            {
              "path": ["data", null, "event_responses_v2", "events_joined", null, "start_timestamp"],
              "arguments": { "factor": 1000 }
            },
            {
              "path": ["data", null, "event_responses_v2", "events_joined", null, "create_timestamp"],
              "arguments": { "factor": 1000 }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "rejected_requests_v2": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "name": [{ "type": "string" }],
                          "timestamp": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            }
                          ],
                          "marked_as_spam": [{ "type": "boolean" }]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "rejected_requests_v2"],
          "category": "Contacts",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "rejected_requests_v2", null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "rejected_requests_v2", null, "timestamp"],
              "arguments": { "factor": 1000 }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "received_requests_v2": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "name": [{ "type": "string" }],
                          "timestamp": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "received_requests_v2"],
          "category": "Contacts",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "received_requests_v2", null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "received_requests_v2", null, "timestamp"],
              "arguments": { "factor": 1000 }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "friends_v2": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "name": [{ "type": "string" }],
                          "timestamp": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "friends_v2"],
          "category": "Contacts",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null, "friends_v2", null] }],
          "selectedTimestamps": [
            {
              "path": ["data", null, "friends_v2", null, "timestamp"],
              "arguments": { "factor": 1000 }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "deleted_friends_v2": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "name": [{ "type": "string" }],
                          "timestamp": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "deleted_friends_v2"],
          "category": "Contacts",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "deleted_friends_v2", null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "deleted_friends_v2", null, "timestamp"],
              "arguments": { "factor": 1000 }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "following_v2": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "name": [{ "type": "string" }],
                          "timestamp": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "following_v2"],
          "category": "Contacts",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null, "following_v2", null] }],
          "selectedTimestamps": [
            {
              "path": ["data", null, "following_v2", null, "timestamp"],
              "arguments": { "factor": 1000 }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "groups_joined_v2": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "timestamp": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            }
                          ],
                          "data": [
                            {
                              "type": "array",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "properties": {
                                    "name": [{ "type": "string" }]
                                  }
                                }
                              ]
                            },
                            { "type": "empty" }
                          ],
                          "title": [{ "type": "string" }]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "groups_joined_v2"],
          "category": "Activity",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "groups_joined_v2", null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "groups_joined_v2", null, "timestamp"],
              "arguments": { "factor": 1000 }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "group_comments_v2": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "timestamp": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            }
                          ],
                          "data": [
                            {
                              "type": "array",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "properties": {
                                    "comment": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "timestamp": [
                                            {
                                              "type": "number",
                                              "supposedUsage": {
                                                "format": "time",
                                                "argument": { "factor": 1000 }
                                              }
                                            }
                                          ],
                                          "comment": [{ "type": "string" }],
                                          "author": [{ "type": "string" }],
                                          "group": [{ "type": "string" }]
                                        }
                                      }
                                    ]
                                  }
                                }
                              ]
                            },
                            { "type": "empty" }
                          ],
                          "title": [{ "type": "string" }]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "group_comments_v2"],
          "category": "Posts",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "group_comments_v2", null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "group_comments_v2", null, "timestamp"],
              "arguments": { "factor": 1000 }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "group_posts_v2": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "timestamp": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            }
                          ],
                          "data": [
                            {
                              "type": "array",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "properties": {
                                    "post": [{ "type": "string" }]
                                  }
                                }
                              ]
                            },
                            { "type": "empty" }
                          ],
                          "title": [{ "type": "string" }, { "type": "empty" }],
                          "attachments": [
                            {
                              "type": "array",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "properties": {
                                    "data": [
                                      {
                                        "type": "array",
                                        "anyOf": [
                                          {
                                            "type": "object",
                                            "properties": {
                                              "media": [
                                                {
                                                  "type": "object",
                                                  "properties": {
                                                    "uri": [
                                                      {
                                                        "type": "string",
                                                        "supposedUsage": {
                                                          "format": "uri"
                                                        }
                                                      }
                                                    ],
                                                    "creation_timestamp": [
                                                      {
                                                        "type": "number",
                                                        "supposedUsage": {
                                                          "format": "time",
                                                          "argument": {
                                                            "factor": 1000
                                                          }
                                                        }
                                                      }
                                                    ],
                                                    "media_metadata": [
                                                      {
                                                        "type": "object",
                                                        "properties": {
                                                          "photo_metadata": [
                                                            {
                                                              "type": "object",
                                                              "properties": {
                                                                "exif_data": [
                                                                  {
                                                                    "type": "array",
                                                                    "anyOf": [
                                                                      {
                                                                        "type": "object",
                                                                        "properties": {
                                                                          "upload_ip": [
                                                                            {
                                                                              "type": "string"
                                                                            }
                                                                          ]
                                                                        }
                                                                      }
                                                                    ]
                                                                  }
                                                                ]
                                                              }
                                                            }
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    "description": [{ "type": "string" }, { "type": "empty" }]
                                                  }
                                                },
                                                { "type": "empty" }
                                              ],
                                              "external_context": [
                                                {
                                                  "type": "object",
                                                  "properties": {
                                                    "url": [{ "type": "string" }]
                                                  }
                                                }
                                              ]
                                            }
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                }
                              ]
                            },
                            { "type": "empty" }
                          ]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "group_posts_v2"],
          "category": "Posts",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null, "group_posts_v2", null] }],
          "selectedTimestamps": [
            {
              "path": ["data", null, "group_posts_v2", null, "timestamp"],
              "arguments": { "factor": 1000 }
            }
          ],
          "selectedUris": [["data", null, "group_posts_v2", null, "attachments", null, "data", null, "media", "uri"]],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "comments_v2": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "timestamp": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            }
                          ],
                          "data": [
                            {
                              "type": "array",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "properties": {
                                    "comment": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "timestamp": [
                                            {
                                              "type": "number",
                                              "supposedUsage": {
                                                "format": "time",
                                                "argument": { "factor": 1000 }
                                              }
                                            }
                                          ],
                                          "comment": [{ "type": "string" }],
                                          "author": [{ "type": "string" }]
                                        }
                                      }
                                    ]
                                  }
                                }
                              ]
                            },
                            { "type": "empty" }
                          ],
                          "title": [{ "type": "string" }],
                          "attachments": [
                            {
                              "type": "array",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "properties": {
                                    "data": [
                                      {
                                        "type": "array",
                                        "anyOf": [
                                          {
                                            "type": "object",
                                            "properties": {
                                              "external_context": [
                                                {
                                                  "type": "object",
                                                  "properties": {
                                                    "url": [{ "type": "string" }]
                                                  }
                                                }
                                              ]
                                            }
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                }
                              ]
                            },
                            { "type": "empty" }
                          ]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "comments_v2"],
          "category": "Posts",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null, "comments_v2", null] }],
          "selectedTimestamps": [
            {
              "path": ["data", null, "comments_v2", null, "timestamp"],
              "arguments": { "factor": 1000 }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "array",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "timestamp": [
                      {
                        "type": "number",
                        "supposedUsage": {
                          "format": "time",
                          "argument": { "factor": 1000 }
                        }
                      }
                    ],
                    "data": [
                      {
                        "type": "array",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "reaction": [
                                {
                                  "type": "object",
                                  "properties": {
                                    "reaction": [{ "type": "string" }],
                                    "actor": [{ "type": "string" }]
                                  }
                                },
                                { "type": "empty" }
                              ],
                              "post": [{ "type": "string" }, { "type": "empty" }],
                              "update_timestamp": [
                                {
                                  "type": "number",
                                  "supposedUsage": {
                                    "format": "time",
                                    "argument": { "factor": 1000 }
                                  }
                                },
                                { "type": "empty" }
                              ]
                            }
                          }
                        ]
                      }
                    ],
                    "title": [{ "type": "string" }, { "type": "empty" }],
                    "attachments": [
                      {
                        "type": "array",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "data": [
                                {
                                  "type": "array",
                                  "anyOf": [
                                    {
                                      "type": "object",
                                      "properties": {
                                        "external_context": [
                                          {
                                            "type": "object",
                                            "properties": {
                                              "url": [{ "type": "string" }]
                                            }
                                          }
                                        ]
                                      }
                                    }
                                  ]
                                }
                              ]
                            }
                          }
                        ]
                      },
                      { "type": "empty" }
                    ]
                  }
                }
              ]
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, null, "data"],
          "category": "Likes",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null, null, "data", null] }],
          "selectedTimestamps": [
            {
              "path": ["data", null, null, "data", null, "update_timestamp"],
              "arguments": { "factor": 1000 }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "primary_location_v2": [
                  {
                    "type": "object",
                    "properties": {
                      "city_region_pairs": [
                        {
                          "type": "array",
                          "anyOf": [{ "type": "array", "anyOf": [{ "type": "string" }] }]
                        }
                      ],
                      "zipcode": [{ "type": "array", "anyOf": [{ "type": "string" }] }]
                    }
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data"],
          "category": "Location",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null] }],
          "selectedTimestamps": [],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "phone_number_location_v2": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "spn": [{ "type": "string" }],
                          "country_code": [{ "type": "string" }]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data"],
          "category": "Location",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null] }],
          "selectedTimestamps": [],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": { "timezone_v2": [{ "type": "string" }] }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data"],
          "category": "Location",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null] }],
          "selectedTimestamps": [],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "topics_v2": [{ "type": "array", "anyOf": [{ "type": "string" }] }]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data"],
          "category": "Security",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null] }],
          "selectedTimestamps": [],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "autofill_information_v2": [
                  {
                    "type": "object",
                    "properties": {
                      "EMAIL": [{ "type": "array", "anyOf": [{ "type": "string" }] }],
                      "PHONE": [{ "type": "array", "anyOf": [{ "type": "string" }] }],
                      "GENDER": [{ "type": "array", "anyOf": [{ "type": "string" }] }],
                      "FIRST_NAME": [{ "type": "array", "anyOf": [{ "type": "string" }] }],
                      "LAST_NAME": [{ "type": "array", "anyOf": [{ "type": "string" }] }],
                      "FULL_NAME": [{ "type": "array", "anyOf": [{ "type": "string" }] }],
                      "WORK_EMAIL": [{ "type": "array", "anyOf": [{ "type": "string" }] }]
                    }
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data"],
          "category": "Messages",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null] }],
          "selectedTimestamps": [],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "support_messages_v2": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "timestamp": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            }
                          ],
                          "subject": [{ "type": "string" }],
                          "messages": [
                            {
                              "type": "array",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "properties": {
                                    "from": [{ "type": "string" }],
                                    "to": [{ "type": "string" }],
                                    "subject": [{ "type": "string" }, { "type": "empty" }],
                                    "message": [{ "type": "string" }],
                                    "timestamp": [
                                      {
                                        "type": "number",
                                        "supposedUsage": {
                                          "format": "time",
                                          "argument": { "factor": 1000 }
                                        }
                                      }
                                    ],
                                    "attachments": [{ "type": "array", "anyOf": [] }]
                                  }
                                }
                              ]
                            }
                          ]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "support_messages_v2"],
          "category": "Messages",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "support_messages_v2", null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "support_messages_v2", null, "timestamp"],
              "arguments": { "factor": 1000 }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "participants": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": { "name": [{ "type": "string" }] }
                      }
                    ]
                  }
                ],
                "messages": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "sender_name": [{ "type": "string" }, { "type": "empty" }],
                          "timestamp_ms": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "iso": true }
                              }
                            }
                          ],
                          "content": [
                            {
                              "type": "string",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "iso": true }
                              }
                            },
                            { "type": "empty" }
                          ],
                          "users": [
                            {
                              "type": "array",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "properties": {
                                    "name": [{ "type": "string" }]
                                  }
                                }
                              ]
                            },
                            { "type": "empty" }
                          ],
                          "sticker": [
                            {
                              "type": "object",
                              "properties": {
                                "uri": [
                                  {
                                    "type": "string",
                                    "supposedUsage": { "format": "uri" }
                                  }
                                ]
                              }
                            },
                            { "type": "empty" }
                          ],
                          "photos": [
                            {
                              "type": "array",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "properties": {
                                    "uri": [
                                      {
                                        "type": "string",
                                        "supposedUsage": { "format": "uri" }
                                      }
                                    ],
                                    "creation_timestamp": [
                                      {
                                        "type": "number",
                                        "supposedUsage": {
                                          "format": "time",
                                          "argument": { "factor": 1000 }
                                        }
                                      },
                                      { "type": "empty" }
                                    ]
                                  }
                                }
                              ]
                            },
                            { "type": "empty" }
                          ],
                          "files": [
                            {
                              "type": "array",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "properties": {
                                    "uri": [
                                      {
                                        "type": "string",
                                        "supposedUsage": { "format": "uri" }
                                      }
                                    ],
                                    "creation_timestamp": [
                                      {
                                        "type": "number",
                                        "supposedUsage": {
                                          "format": "time",
                                          "argument": { "factor": 1000 }
                                        }
                                      }
                                    ]
                                  }
                                }
                              ]
                            },
                            { "type": "empty" }
                          ],
                          "share": [
                            {
                              "type": "object",
                              "properties": {
                                "link": [{ "type": "string" }],
                                "share_text": [{ "type": "string" }, { "type": "empty" }]
                              }
                            },
                            { "type": "empty" }
                          ],
                          "call_duration": [{ "type": "number" }, { "type": "empty" }],
                          "missed": [{ "type": "boolean" }, { "type": "empty" }],
                          "audio_files": [
                            {
                              "type": "array",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "properties": {
                                    "uri": [
                                      {
                                        "type": "string",
                                        "supposedUsage": { "format": "uri" }
                                      }
                                    ],
                                    "creation_timestamp": [
                                      {
                                        "type": "number",
                                        "supposedUsage": {
                                          "format": "time",
                                          "argument": { "factor": 1000 }
                                        }
                                      }
                                    ]
                                  }
                                }
                              ]
                            },
                            { "type": "empty" }
                          ],
                          "ip": [{ "type": "string" }, { "type": "empty" }]
                        }
                      }
                    ]
                  }
                ],
                "title": [
                  {
                    "type": "string",
                    "supposedUsage": {
                      "format": "time",
                      "argument": { "lang": "en" }
                    }
                  },
                  { "type": "empty" }
                ],
                "is_still_participant": [{ "type": "boolean" }],
                "thread_path": [{ "type": "string" }],
                "magic_words": [{ "type": "array", "anyOf": [] }],
                "joinable_mode": [
                  {
                    "type": "object",
                    "properties": {
                      "mode": [{ "type": "number" }],
                      "link": [{ "type": "string" }, { "type": "empty" }]
                    }
                  },
                  { "type": "empty" }
                ],
                "is_pending": [{ "type": "boolean" }, { "type": "empty" }]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "messages"],
          "category": "Messages",
          "subcategory": [
            { "type": "text", "value": "Chat with " },
            {
              "type": "data",
              "value": ["data", null, "participants", null, "name"]
            }
          ],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "messages", null, "sender_name"]
            },
            { "type": "text", "value": ": " },
            {
              "type": "data",
              "value": ["data", null, "messages", null, "content"]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "messages", null, "timestamp_ms"],
              "arguments": { "iso": true },
              "template": ["data", null, "messages"]
            }
          ],
          "selectedUris": [
            ["data", null, "messages", null, "sticker", "uri"],
            ["data", null, "messages", null, "photos", null, "uri"],
            ["data", null, "messages", null, "files", null, "uri"],
            ["data", null, "messages", null, "audio_files", null, "uri"]
          ],
          "selectedContacts": [["data", null, "participants", null, "name"]],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "controls": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "name": [{ "type": "string" }],
                          "description": [{ "type": "string" }],
                          "entries": [{ "type": "array", "anyOf": [] }]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "controls"],
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null, "controls", null] }],
          "selectedTimestamps": [],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "people_and_friends_v2": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "name": [{ "type": "string" }],
                          "description": [{ "type": "string" }],
                          "entries": [
                            {
                              "type": "array",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "properties": {
                                    "timestamp": [
                                      {
                                        "type": "number",
                                        "supposedUsage": {
                                          "format": "time",
                                          "argument": { "factor": 1000 }
                                        }
                                      }
                                    ],
                                    "data": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "name": [{ "type": "string" }],
                                          "uri": [{ "type": "string" }]
                                        }
                                      }
                                    ]
                                  }
                                }
                              ]
                            }
                          ]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "people_and_friends_v2", null, "entries"],
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "people_and_friends_v2", null, "entries", null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "people_and_friends_v2", null, "entries", null, "timestamp"],
              "arguments": { "factor": 1000 }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "reduce": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "name": [{ "type": "string" }],
                          "description": [{ "type": "string" }],
                          "entries": [
                            {
                              "type": "array",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "properties": {
                                    "data": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "name": [{ "type": "string" }],
                                          "value": [{ "type": "string" }]
                                        }
                                      }
                                    ]
                                  }
                                }
                              ]
                            }
                          ]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "reduce"],
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null, "reduce", null] }],
          "selectedTimestamps": [],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "pages_followed_v2": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "timestamp": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            }
                          ],
                          "data": [
                            {
                              "type": "array",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "properties": {
                                    "name": [{ "type": "string" }]
                                  }
                                }
                              ]
                            }
                          ],
                          "title": [{ "type": "string" }]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "pages_followed_v2"],
          "category": "Contacts",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "pages_followed_v2", null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "pages_followed_v2", null, "timestamp"],
              "arguments": { "factor": 1000 }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "pages_unfollowed_v2": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "timestamp": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            }
                          ],
                          "data": [
                            {
                              "type": "array",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "properties": {
                                    "name": [{ "type": "string" }]
                                  }
                                }
                              ]
                            }
                          ],
                          "title": [{ "type": "string" }]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "pages_unfollowed_v2"],
          "category": "Contacts",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "pages_unfollowed_v2", null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "pages_unfollowed_v2", null, "timestamp"],
              "arguments": { "factor": 1000 }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "page_likes_v2": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "name": [{ "type": "string" }],
                          "timestamp": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            }
                          ],
                          "url": [{ "type": "string" }]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "page_likes_v2"],
          "category": "Likes",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null, "page_likes_v2", null] }],
          "selectedTimestamps": [
            {
              "path": ["data", null, "page_likes_v2", null, "timestamp"],
              "arguments": { "factor": 1000 }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "payments_v2": [
                  {
                    "type": "object",
                    "properties": {
                      "preferred_currency": [{ "type": "string" }],
                      "payments": [{ "type": "array", "anyOf": [] }]
                    }
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data"],
          "category": "Activity",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null] }],
          "selectedTimestamps": [],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "address_book_v2": [
                  {
                    "type": "object",
                    "properties": {
                      "address_book": [
                        {
                          "type": "array",
                          "anyOf": [
                            {
                              "type": "object",
                              "properties": {
                                "name": [{ "type": "string" }],
                                "details": [
                                  {
                                    "type": "array",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "contact_point": [{ "type": "string" }]
                                        }
                                      }
                                    ]
                                  }
                                ],
                                "created_timestamp": [
                                  {
                                    "type": "number",
                                    "supposedUsage": {
                                      "format": "time",
                                      "argument": { "factor": 1000 }
                                    }
                                  }
                                ],
                                "updated_timestamp": [
                                  {
                                    "type": "number",
                                    "supposedUsage": {
                                      "format": "time",
                                      "argument": { "factor": 1000 }
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "address_book_v2", "address_book"],
          "category": "Activity",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "address_book_v2", "address_book", null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "address_book_v2", "address_book", null, "created_timestamp"],
              "arguments": { "factor": 1000 }
            },
            {
              "path": ["data", null, "address_book_v2", "address_book", null, "updated_timestamp"],
              "arguments": { "factor": 1000 }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "poll_votes_v2": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "timestamp": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            }
                          ],
                          "attachments": [
                            {
                              "type": "array",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "properties": {
                                    "data": [
                                      {
                                        "type": "array",
                                        "anyOf": [
                                          {
                                            "type": "object",
                                            "properties": {
                                              "poll": [
                                                {
                                                  "type": "object",
                                                  "properties": {
                                                    "options": [
                                                      {
                                                        "type": "array",
                                                        "anyOf": [
                                                          {
                                                            "type": "object",
                                                            "properties": {
                                                              "option": [
                                                                {
                                                                  "type": "string"
                                                                }
                                                              ],
                                                              "voted": [
                                                                {
                                                                  "type": "boolean"
                                                                }
                                                              ]
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                }
                                              ]
                                            }
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                }
                              ]
                            }
                          ],
                          "title": [{ "type": "string" }]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "poll_votes_v2"],
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null, "poll_votes_v2", null] }],
          "selectedTimestamps": [
            {
              "path": ["data", null, "poll_votes_v2", null, "timestamp"],
              "arguments": { "factor": 1000 }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "name": [{ "type": "string" }],
                "photos": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "uri": [
                            {
                              "type": "string",
                              "supposedUsage": { "format": "uri" }
                            }
                          ],
                          "creation_timestamp": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            }
                          ],
                          "media_metadata": [
                            {
                              "type": "object",
                              "properties": {
                                "photo_metadata": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "exif_data": [
                                        {
                                          "type": "array",
                                          "anyOf": [
                                            {
                                              "type": "object",
                                              "properties": {
                                                "upload_ip": [{ "type": "string" }],
                                                "taken_timestamp": [
                                                  {
                                                    "type": "number",
                                                    "supposedUsage": {
                                                      "format": "time",
                                                      "argument": {
                                                        "factor": 1000
                                                      }
                                                    }
                                                  }
                                                ]
                                              }
                                            }
                                          ]
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ],
                          "title": [{ "type": "string" }]
                        }
                      }
                    ]
                  }
                ],
                "cover_photo": [
                  {
                    "type": "object",
                    "properties": {
                      "uri": [
                        {
                          "type": "string",
                          "supposedUsage": { "format": "uri" }
                        }
                      ],
                      "creation_timestamp": [
                        {
                          "type": "number",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 1000 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "media_metadata": [
                        {
                          "type": "object",
                          "properties": {
                            "photo_metadata": [
                              {
                                "type": "object",
                                "properties": {
                                  "exif_data": [
                                    {
                                      "type": "array",
                                      "anyOf": [
                                        {
                                          "type": "object",
                                          "properties": {
                                            "upload_ip": [{ "type": "string" }],
                                            "taken_timestamp": [
                                              {
                                                "type": "number",
                                                "supposedUsage": {
                                                  "format": "time",
                                                  "argument": { "factor": 1000 }
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  ]
                                }
                              }
                            ]
                          }
                        },
                        { "type": "empty" }
                      ],
                      "title": [{ "type": "string" }, { "type": "empty" }]
                    }
                  }
                ],
                "last_modified_timestamp": [
                  {
                    "type": "number",
                    "supposedUsage": {
                      "format": "time",
                      "argument": { "factor": 1000 }
                    }
                  }
                ],
                "description": [{ "type": "string" }, { "type": "empty" }]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data"],
          "category": "Posts",
          "subcategory": [{ "type": "data", "value": ["data", null, "name"] }],
          "content": [{ "type": "data", "value": ["data", null] }],
          "selectedTimestamps": [
            {
              "path": ["data", null, "cover_photo", "creation_timestamp"],
              "arguments": { "factor": 1000 }
            },
            {
              "path": ["data", null, "last_modified_timestamp"],
              "arguments": { "factor": 1000 }
            }
          ],
          "selectedUris": [
            ["data", null, "photos", null, "uri"],
            ["data", null, "cover_photo", "uri"]
          ],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "other_photos_v2": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "uri": [
                            {
                              "type": "string",
                              "supposedUsage": { "format": "uri" }
                            }
                          ],
                          "creation_timestamp": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            }
                          ],
                          "media_metadata": [
                            {
                              "type": "object",
                              "properties": {
                                "photo_metadata": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "exif_data": [
                                        {
                                          "type": "array",
                                          "anyOf": [
                                            {
                                              "type": "object",
                                              "properties": {
                                                "upload_ip": [{ "type": "string" }]
                                              }
                                            }
                                          ]
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ],
                          "description": [{ "type": "string" }, { "type": "empty" }]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "other_photos_v2"],
          "category": "Posts",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null, "other_photos_v2", null] }],
          "selectedTimestamps": [
            {
              "path": ["data", null, "other_photos_v2", null, "creation_timestamp"],
              "arguments": { "factor": 1000 }
            }
          ],
          "selectedUris": [["data", null, "other_photos_v2", null, "uri"]],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "language_and_locale_v2": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "name": [{ "type": "string" }],
                          "description": [{ "type": "string" }],
                          "children": [
                            {
                              "type": "array",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "properties": {
                                    "name": [{ "type": "string" }],
                                    "description": [{ "type": "string" }],
                                    "entries": [
                                      {
                                        "type": "array",
                                        "anyOf": [
                                          {
                                            "type": "object",
                                            "properties": {
                                              "data": [
                                                {
                                                  "type": "object",
                                                  "properties": {
                                                    "value": [{ "type": "string" }, { "type": "empty" }],
                                                    "name": [{ "type": "string" }]
                                                  }
                                                }
                                              ],
                                              "timestamp": [
                                                {
                                                  "type": "number",
                                                  "supposedUsage": {
                                                    "format": "time",
                                                    "argument": {
                                                      "factor": 1000
                                                    }
                                                  }
                                                }
                                              ]
                                            }
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                }
                              ]
                            },
                            { "type": "empty" }
                          ],
                          "entries": [
                            {
                              "type": "array",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "properties": {
                                    "data": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": [{ "type": "string" }]
                                        }
                                      }
                                    ]
                                  }
                                }
                              ]
                            }
                          ]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "language_and_locale_v2", null, "children", null, "entries"],
          "category": "Location",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "language_and_locale_v2", null, "children", null, "entries", null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "language_and_locale_v2", null, "children", null, "entries", null, "timestamp"],
              "arguments": { "factor": 1000 }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "profile_v2": [
                  {
                    "type": "object",
                    "properties": {
                      "name": [
                        {
                          "type": "object",
                          "properties": {
                            "full_name": [{ "type": "string" }],
                            "first_name": [{ "type": "string" }],
                            "middle_name": [{ "type": "string" }, { "type": "empty" }],
                            "last_name": [{ "type": "string" }]
                          }
                        }
                      ],
                      "emails": [
                        {
                          "type": "object",
                          "properties": {
                            "emails": [
                              {
                                "type": "array",
                                "anyOf": [{ "type": "string" }]
                              }
                            ],
                            "previous_emails": [
                              {
                                "type": "array",
                                "anyOf": [{ "type": "string" }]
                              }
                            ],
                            "pending_emails": [{ "type": "array", "anyOf": [] }],
                            "ad_account_emails": [{ "type": "array", "anyOf": [] }]
                          }
                        }
                      ],
                      "birthday": [
                        {
                          "type": "object",
                          "properties": {
                            "year": [{ "type": "number" }],
                            "month": [{ "type": "number" }],
                            "day": [{ "type": "number" }]
                          }
                        }
                      ],
                      "gender": [
                        {
                          "type": "object",
                          "properties": {
                            "gender_option": [{ "type": "string" }],
                            "pronoun": [{ "type": "string" }]
                          }
                        }
                      ],
                      "previous_names": [
                        {
                          "type": "array",
                          "anyOf": [
                            {
                              "type": "object",
                              "properties": {
                                "name": [{ "type": "string" }],
                                "timestamp": [
                                  {
                                    "type": "number",
                                    "supposedUsage": {
                                      "format": "time",
                                      "argument": { "factor": 1000 }
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      ],
                      "other_names": [{ "type": "array", "anyOf": [] }],
                      "education_experiences": [{ "type": "array", "anyOf": [] }],
                      "work_experiences": [{ "type": "array", "anyOf": [] }],
                      "blood_info": [
                        {
                          "type": "object",
                          "properties": {
                            "blood_donor_status": [{ "type": "string" }]
                          }
                        }
                      ],
                      "websites": [{ "type": "array", "anyOf": [] }],
                      "phone_numbers": [
                        {
                          "type": "array",
                          "anyOf": [
                            {
                              "type": "object",
                              "properties": {
                                "phone_type": [{ "type": "string" }],
                                "phone_number": [{ "type": "string" }],
                                "verified": [{ "type": "boolean" }]
                              }
                            }
                          ]
                        }
                      ],
                      "registration_timestamp": [
                        {
                          "type": "number",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 1000 }
                          }
                        }
                      ],
                      "profile_uri": [{ "type": "string" }]
                    }
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data"],
          "category": "Account",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null] }],
          "selectedTimestamps": [
            {
              "path": ["data", null, "profile_v2", "registration_timestamp"],
              "arguments": { "factor": 1000 }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "profile_updates_v2": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "timestamp": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            }
                          ],
                          "title": [{ "type": "string" }],
                          "attachments": [
                            {
                              "type": "array",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "properties": {
                                    "data": [
                                      {
                                        "type": "array",
                                        "anyOf": [
                                          {
                                            "type": "object",
                                            "properties": {
                                              "media": [
                                                {
                                                  "type": "object",
                                                  "properties": {
                                                    "uri": [
                                                      {
                                                        "type": "string",
                                                        "supposedUsage": {
                                                          "format": "uri"
                                                        }
                                                      }
                                                    ],
                                                    "creation_timestamp": [
                                                      {
                                                        "type": "number",
                                                        "supposedUsage": {
                                                          "format": "time",
                                                          "argument": {
                                                            "factor": 1000
                                                          }
                                                        }
                                                      }
                                                    ],
                                                    "media_metadata": [
                                                      {
                                                        "type": "object",
                                                        "properties": {
                                                          "photo_metadata": [
                                                            {
                                                              "type": "object",
                                                              "properties": {
                                                                "exif_data": [
                                                                  {
                                                                    "type": "array",
                                                                    "anyOf": [
                                                                      {
                                                                        "type": "object",
                                                                        "properties": {
                                                                          "upload_ip": [
                                                                            {
                                                                              "type": "string"
                                                                            }
                                                                          ],
                                                                          "taken_timestamp": [
                                                                            {
                                                                              "type": "number",
                                                                              "supposedUsage": {
                                                                                "format": "time",
                                                                                "argument": {
                                                                                  "factor": 1000
                                                                                }
                                                                              }
                                                                            }
                                                                          ]
                                                                        }
                                                                      }
                                                                    ]
                                                                  }
                                                                ]
                                                              }
                                                            }
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    "title": [{ "type": "string" }]
                                                  }
                                                }
                                              ]
                                            }
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                }
                              ]
                            },
                            { "type": "empty" }
                          ]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "profile_updates_v2"],
          "category": "Account",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "profile_updates_v2", null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "profile_updates_v2", null, "timestamp"],
              "arguments": { "factor": 1000 }
            }
          ],
          "selectedUris": [
            ["data", null, "profile_updates_v2", null, "attachments", null, "data", null, "media", "uri"]
          ],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "inferred_topics_v2": [{ "type": "array", "anyOf": [{ "type": "string" }] }]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data"],
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null] }],
          "selectedTimestamps": [],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "saves_v2": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "timestamp": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            }
                          ],
                          "title": [{ "type": "string" }]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "saves_v2"],
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null, "saves_v2", null] }],
          "selectedTimestamps": [
            {
              "path": ["data", null, "saves_v2", null, "timestamp"],
              "arguments": { "factor": 1000 }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "searches_v2": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "timestamp": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            }
                          ],
                          "attachments": [
                            {
                              "type": "array",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "properties": {
                                    "data": [
                                      {
                                        "type": "array",
                                        "anyOf": [
                                          {
                                            "type": "object",
                                            "properties": {
                                              "text": [{ "type": "string" }]
                                            }
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                }
                              ]
                            }
                          ],
                          "data": [
                            {
                              "type": "array",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "properties": {
                                    "text": [{ "type": "string" }]
                                  }
                                }
                              ]
                            }
                          ],
                          "title": [{ "type": "string" }]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "searches_v2"],
          "category": "Activity",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null, "searches_v2", null] }],
          "selectedTimestamps": [
            {
              "path": ["data", null, "searches_v2", null, "timestamp"],
              "arguments": { "factor": 1000 }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "recently_viewed": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "name": [{ "type": "string" }],
                          "description": [{ "type": "string" }],
                          "children": [
                            {
                              "type": "array",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "properties": {
                                    "name": [{ "type": "string" }],
                                    "description": [{ "type": "string" }],
                                    "entries": [
                                      {
                                        "type": "array",
                                        "anyOf": [
                                          {
                                            "type": "object",
                                            "properties": {
                                              "timestamp": [
                                                {
                                                  "type": "number",
                                                  "supposedUsage": {
                                                    "format": "time",
                                                    "argument": {
                                                      "factor": 1000
                                                    }
                                                  }
                                                },
                                                { "type": "empty" }
                                              ],
                                              "data": [
                                                {
                                                  "type": "object",
                                                  "properties": {
                                                    "name": [{ "type": "string" }, { "type": "empty" }],
                                                    "uri": [{ "type": "string" }, { "type": "empty" }],
                                                    "watch_time": [{ "type": "string" }, { "type": "empty" }],
                                                    "watch_position_seconds": [
                                                      { "type": "string" },
                                                      { "type": "empty" }
                                                    ],
                                                    "value": [{ "type": "string" }, { "type": "empty" }]
                                                  }
                                                }
                                              ]
                                            }
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                }
                              ]
                            }
                          ]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "recently_viewed", null, "children", null, "entries"],
          "category": "Activity",
          "subcategory": [
            {
              "type": "data",
              "value": ["data", null, "recently_viewed", null, "children", null, "name"]
            },
            { "type": "text", "value": " on " },
            {
              "type": "data",
              "value": ["data", null, "recently_viewed", null, "name"]
            }
          ],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "recently_viewed", null, "children", null, "entries", null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "recently_viewed", null, "children", null, "entries", null, "timestamp"],
              "arguments": { "factor": 1000 }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "visited_things_v2": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "name": [{ "type": "string" }],
                          "description": [{ "type": "string" }],
                          "entries": [
                            {
                              "type": "array",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "properties": {
                                    "timestamp": [
                                      {
                                        "type": "number",
                                        "supposedUsage": {
                                          "format": "time",
                                          "argument": { "factor": 1000 }
                                        }
                                      },
                                      { "type": "empty" }
                                    ],
                                    "data": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "name": [{ "type": "string" }, { "type": "empty" }],
                                          "uri": [{ "type": "string" }, { "type": "empty" }],
                                          "value": [
                                            {
                                              "type": "string",
                                              "supposedUsage": {
                                                "format": "time",
                                                "argument": { "lang": "en" }
                                              }
                                            }
                                          ]
                                        }
                                      }
                                    ]
                                  }
                                }
                              ]
                            }
                          ]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "visited_things_v2", null, "entries"],
          "category": "Activity",
          "subcategory": [
            {
              "type": "data",
              "value": ["data", null, "visited_things_v2", null, "name"]
            }
          ],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "visited_things_v2", null, "entries", null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "visited_things_v2", null, "entries", null, "timestamp"],
              "arguments": { "factor": 1000 }
            },
            {
              "path": ["data", null, "visited_things_v2", null, "entries", null, "data", "value"],
              "arguments": { "lang": "en" }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "news_your_locations_v2": [{ "type": "array", "anyOf": [{ "type": "string" }] }]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data"],
          "category": "Location",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null] }],
          "selectedTimestamps": [],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "notification_meta_privacy_policy_update": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "impression_time": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            }
                          ],
                          "consent_state": [{ "type": "number" }]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "notification_meta_privacy_policy_update"],
          "category": "Messages",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "notification_meta_privacy_policy_update", null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "notification_meta_privacy_policy_update", null, "impression_time"],
              "arguments": { "factor": 1000 }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "notifications_v2": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "timestamp": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            }
                          ],
                          "unread": [{ "type": "boolean" }],
                          "href": [{ "type": "string" }],
                          "text": [{ "type": "string" }]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "notifications_v2"],
          "category": "Messages",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "notifications_v2", null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "notifications_v2", null, "timestamp"],
              "arguments": { "factor": 1000 }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "admin_records_v2": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "event": [{ "type": "string" }],
                          "session": [
                            {
                              "type": "object",
                              "properties": {
                                "created_timestamp": [
                                  {
                                    "type": "number",
                                    "supposedUsage": {
                                      "format": "time",
                                      "argument": { "factor": 1000 }
                                    }
                                  }
                                ],
                                "ip_address": [{ "type": "string" }, { "type": "empty" }],
                                "user_agent": [{ "type": "string" }],
                                "datr_cookie": [{ "type": "string" }]
                              }
                            }
                          ],
                          "extra_info": [
                            {
                              "type": "object",
                              "properties": {
                                "old_name": [{ "type": "string" }],
                                "new_name": [{ "type": "string" }],
                                "old_number": [{ "type": "string" }, { "type": "empty" }],
                                "old_vanity": [{ "type": "string" }, { "type": "empty" }],
                                "new_vanity": [{ "type": "string" }, { "type": "empty" }],
                                "old_email": [{ "type": "string" }, { "type": "empty" }],
                                "new_email": [{ "type": "string" }, { "type": "empty" }],
                                "new_number": [{ "type": "string" }, { "type": "empty" }]
                              }
                            },
                            { "type": "empty" }
                          ]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "admin_records_v2"],
          "category": "Security",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "admin_records_v2", null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "admin_records_v2", null, "session", "created_timestamp"],
              "arguments": { "factor": 1000 }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "used_ip_address_v2": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "ip": [{ "type": "string" }],
                          "action": [{ "type": "string" }],
                          "timestamp": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            }
                          ],
                          "user_agent": [{ "type": "string" }]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "used_ip_address_v2"],
          "category": "Security",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "used_ip_address_v2", null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "used_ip_address_v2", null, "timestamp"],
              "arguments": { "factor": 1000 }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "account_accesses_v2": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "action": [{ "type": "string" }],
                          "timestamp": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            }
                          ],
                          "site": [{ "type": "string" }],
                          "ip_address": [{ "type": "string" }]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "account_accesses_v2"],
          "category": "Security",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "account_accesses_v2", null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "account_accesses_v2", null, "timestamp"],
              "arguments": { "factor": 1000 }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "recognized_devices_v2": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "name": [
                            {
                              "type": "string",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "iso": true }
                              }
                            }
                          ],
                          "created_timestamp": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            }
                          ],
                          "updated_timestamp": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            },
                            { "type": "empty" }
                          ],
                          "ip_address": [{ "type": "string" }],
                          "datr_cookie": [{ "type": "string" }],
                          "user_agent": [{ "type": "string" }]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "recognized_devices_v2"],
          "category": "Security",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "recognized_devices_v2", null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "recognized_devices_v2", null, "updated_timestamp"],
              "arguments": { "factor": 1000 }
            },
            {
              "path": ["data", null, "recognized_devices_v2", null, "created_timestamp"],
              "arguments": { "factor": 1000 }
            },
            {
              "path": ["data", null, "recognized_devices_v2", null, "name"],
              "arguments": { "iso": true }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "datr_stats_v2": [
                  {
                    "type": "object",
                    "properties": {
                      "r8Em********************": [
                        {
                          "type": "array",
                          "anyOf": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            }
                          ]
                        }
                      ],
                      "foeG********************": [
                        {
                          "type": "array",
                          "anyOf": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            }
                          ]
                        }
                      ],
                      "8hT0********************": [
                        {
                          "type": "array",
                          "anyOf": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            }
                          ]
                        }
                      ],
                      "ABQu********************": [
                        {
                          "type": "array",
                          "anyOf": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            }
                          ]
                        }
                      ],
                      "aFwQ********************": [
                        {
                          "type": "array",
                          "anyOf": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            }
                          ]
                        }
                      ],
                      "eOf_********************": [
                        {
                          "type": "array",
                          "anyOf": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            }
                          ]
                        }
                      ],
                      "tE7M********************": [
                        {
                          "type": "array",
                          "anyOf": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            }
                          ]
                        }
                      ],
                      "Y0SZ********************": [
                        {
                          "type": "array",
                          "anyOf": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            }
                          ]
                        }
                      ],
                      "QKCl********************": [
                        {
                          "type": "array",
                          "anyOf": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data"],
          "category": "Security",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null] }],
          "selectedTimestamps": [],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "login_protection_data_v2": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "name": [{ "type": "string" }],
                          "session": [
                            {
                              "type": "object",
                              "properties": {
                                "created_timestamp": [
                                  {
                                    "type": "number",
                                    "supposedUsage": {
                                      "format": "time",
                                      "argument": { "factor": 1000 }
                                    }
                                  }
                                ],
                                "updated_timestamp": [
                                  {
                                    "type": "number",
                                    "supposedUsage": {
                                      "format": "time",
                                      "argument": { "factor": 1000 }
                                    }
                                  },
                                  { "type": "empty" }
                                ],
                                "ip_address": [{ "type": "string" }, { "type": "empty" }]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "login_protection_data_v2"],
          "category": "Security",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "login_protection_data_v2", null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "login_protection_data_v2", null, "session", "updated_timestamp"],
              "arguments": { "factor": 1000 }
            },
            {
              "path": ["data", null, "login_protection_data_v2", null, "session", "created_timestamp"],
              "arguments": { "factor": 1000 }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "last_activity_v2": [
                  {
                    "type": "object",
                    "properties": {
                      "last_activity_time": [
                        {
                          "type": "object",
                          "properties": {
                            "Website": [
                              {
                                "type": "object",
                                "properties": {
                                  "activity_by_day": [
                                    {
                                      "type": "array",
                                      "anyOf": [
                                        {
                                          "type": "number",
                                          "supposedUsage": {
                                            "format": "time",
                                            "argument": { "factor": 1000 }
                                          }
                                        }
                                      ]
                                    }
                                  ]
                                }
                              }
                            ],
                            "Facebook-App": [
                              {
                                "type": "object",
                                "properties": {
                                  "activity_by_day": [
                                    {
                                      "type": "array",
                                      "anyOf": [
                                        {
                                          "type": "number",
                                          "supposedUsage": {
                                            "format": "time",
                                            "argument": { "factor": 1000 }
                                          }
                                        }
                                      ]
                                    }
                                  ]
                                }
                              }
                            ],
                            "Facebook Lite": [
                              {
                                "type": "object",
                                "properties": {
                                  "activity_by_day": [
                                    {
                                      "type": "array",
                                      "anyOf": [
                                        {
                                          "type": "number",
                                          "supposedUsage": {
                                            "format": "time",
                                            "argument": { "factor": 1000 }
                                          }
                                        }
                                      ]
                                    }
                                  ]
                                }
                              }
                            ]
                          }
                        }
                      ]
                    }
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data"],
          "category": "Security",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null] }],
          "selectedTimestamps": [],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "contact_verifications_v2": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "contact": [{ "type": "string" }],
                          "contact_type": [{ "type": "number" }],
                          "verification_time": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "contact_verifications_v2"],
          "category": "Messages",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "contact_verifications_v2", null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "contact_verifications_v2", null, "verification_time"],
              "arguments": { "factor": 1000 }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "active_sessions_v2": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "created_timestamp": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            }
                          ],
                          "updated_timestamp": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            }
                          ],
                          "ip_address": [{ "type": "string" }],
                          "user_agent": [{ "type": "string" }],
                          "datr_cookie": [{ "type": "string" }],
                          "device": [{ "type": "string" }],
                          "location": [{ "type": "string" }],
                          "app": [{ "type": "string" }],
                          "session_type": [{ "type": "string" }],
                          "name": [
                            {
                              "type": "string",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "iso": true }
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "active_sessions_v2"],
          "category": "Security",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "active_sessions_v2", null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "active_sessions_v2", null, "updated_timestamp"],
              "arguments": { "factor": 1000 }
            },
            {
              "path": ["data", null, "active_sessions_v2", null, "created_timestamp"],
              "arguments": { "factor": 1000 }
            },
            {
              "path": ["data", null, "active_sessions_v2", null, "name"],
              "arguments": { "iso": true }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "account_activity_v2": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "action": [{ "type": "string" }],
                          "timestamp": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            }
                          ],
                          "ip_address": [{ "type": "string" }],
                          "user_agent": [{ "type": "string" }],
                          "datr_cookie": [{ "type": "string" }, { "type": "empty" }],
                          "city": [{ "type": "string" }],
                          "region": [{ "type": "string" }],
                          "country": [{ "type": "string" }],
                          "site_name": [{ "type": "string" }, { "type": "empty" }]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "account_activity_v2"],
          "category": "Security",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "account_activity_v2", null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "account_activity_v2", null, "timestamp"],
              "arguments": { "factor": 1000 }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "devices_v2": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "type": [{ "type": "string" }],
                          "os": [
                            {
                              "type": "string",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "iso": true }
                              }
                            }
                          ],
                          "update_time": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            }
                          ],
                          "advertiser_id": [{ "type": "string" }],
                          "udid": [{ "type": "string" }],
                          "redact_tokens": [{ "type": "array", "anyOf": [{ "type": "string" }] }],
                          "push_tokens": [
                            {
                              "type": "array",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "properties": {
                                    "disabled": [{ "type": "boolean" }],
                                    "client_update_time": [
                                      {
                                        "type": "number",
                                        "supposedUsage": {
                                          "format": "time",
                                          "argument": { "factor": 1000 }
                                        }
                                      }
                                    ],
                                    "creation_time": [
                                      {
                                        "type": "number",
                                        "supposedUsage": {
                                          "format": "time",
                                          "argument": { "factor": 1000 }
                                        }
                                      }
                                    ],
                                    "app_version": [{ "type": "string" }],
                                    "locale": [{ "type": "string" }],
                                    "os_version": [{ "type": "string" }],
                                    "token": [{ "type": "string" }],
                                    "device_id": [{ "type": "string" }]
                                  }
                                }
                              ]
                            }
                          ],
                          "family_device_id": [{ "type": "string" }],
                          "device_locale": [{ "type": "string" }]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "devices_v2"],
          "category": "Security",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null, "devices_v2", null] }],
          "selectedTimestamps": [
            {
              "path": ["data", null, "devices_v2", null, "update_time"],
              "arguments": { "factor": 1000 }
            },
            {
              "path": ["data", null, "devices_v2", null, "os"],
              "arguments": { "iso": true }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "account_status_changes_v2": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "status": [{ "type": "string" }],
                          "timestamp": [
                            {
                              "type": "number",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 1000 }
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null, "account_status_changes_v2"],
          "category": "Security",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [
            {
              "type": "data",
              "value": ["data", null, "account_status_changes_v2", null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, "account_status_changes_v2", null, "timestamp"],
              "arguments": { "factor": 1000 }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    }
  ],
  "fileStructure": [
    "activity_messages/",
    "ads_information/",
    "apps_and_websites_off_of_facebook/",
    "voting_location_and_reminders/",
    "events/",
    "friends_and_followers/",
    "groups/",
    "comments_and_reactions/",
    "posts/",
    "location/",
    "other_logged_information/",
    "messages/",
    "feed/",
    "pages_and_profiles/",
    "facebook_payments/",
    "other_personal_information/",
    "polls/",
    "preferences/",
    "profile_information/",
    "your_topics/",
    "saved_items_and_collections/",
    "search/",
    "your_interactions_on_facebook/",
    "facebook_news/",
    "notifications/",
    "security_and_login_information/",
    "facebook_accounts_center/",
    "collaborations/",
    "facebook_gaming/",
    "facebook_marketplace/",
    "facebook_assistant/",
    "form_submissions/",
    "fundraisers/",
    "journalist_registration/",
    "short_videos/",
    "live_audio_rooms/",
    "music_recommendations/",
    "navigation_bar/",
    "your_places/",
    "facebook_portal/",
    "privacy_checkup/",
    "reviews/",
    "your_problem_reports/",
    "shops/",
    "meta_spark/",
    "stories/",
    "bug_bounty/",
    "other_activity/"
  ],
  "optionalFileStructure": []
}
